import { IGroupMemberStats } from '@grassrootly/api/entities';
import { provider } from "@grassrootly/api/providers";
import { GetMembersWithStatsParams } from './GetGroupMembersWithAvgRatings';

export const GetGroupMembersWithExpPoints = async (params: GetMembersWithStatsParams):
  Promise<IGroupMemberStats[]> =>
  provider.Request("/get_top_experience_points_by_group", params);
